import { defineMessages } from 'react-intl';

export const TOPIC_FILTER_FAVORITE = 'favorite';
export const TOPIC_FILTER_NEW = 'new';
export const TOPIC_FILTER_POPULAR = 'popular';
export const TOPIC_FILTER_PARTICIPATED = 'participated';
export const TOPIC_FILTER_READ = 'read';
export const TOPIC_FILTER_UNANSWERED = 'unanswered';
export const TOPIC_FILTER_CREATED = 'created';

export const filterMessages = defineMessages({
  [TOPIC_FILTER_FAVORITE]: { defaultMessage: 'Favorite topics', id: 'Q7C/0+' },
  [TOPIC_FILTER_NEW]: { defaultMessage: 'New topics', id: 't1zI4h' },
  [TOPIC_FILTER_POPULAR]: { defaultMessage: 'Most discussed topics', id: 'rbSlrV' },
  [TOPIC_FILTER_PARTICIPATED]: { defaultMessage: 'Commented topics', id: 'cksmw4' },
  [TOPIC_FILTER_READ]: { defaultMessage: 'Topics currently being read', id: 'SemQY0' },
  [TOPIC_FILTER_UNANSWERED]: { defaultMessage: 'Topics without response', id: 'nDoZfq' },
  [TOPIC_FILTER_CREATED]: { defaultMessage: 'Created topics', id: 'Ncd6DT' },
});

export const topicsFilterOrder = Object.keys(filterMessages);

export const topicsConnectedOnlyMap = {
  [TOPIC_FILTER_FAVORITE]: true,
  [TOPIC_FILTER_PARTICIPATED]: true,
  [TOPIC_FILTER_READ]: true,
  [TOPIC_FILTER_CREATED]: true,
};
